export const HOTJAR_EVENTS = {
  CANCEL_ACCOUNT: "cancel_account",
  CANCEL_SUBSCRIPTION: "cancel_subscription",
} as const;

export interface HotjarUserTraits {
  acctExpireDate?: string;
  isCoached?: boolean;
  acctType?: string;
}

export const identifyHotjarUser = (userId: number, traits: HotjarUserTraits): void => {
  window.hj?.("identify", userId, traits);
};

export const triggerHotjarEvent = (event: string): void => {
  window.hj?.("event", event);
};
